function ActivateMenu() {
  const anchors = document.querySelectorAll(
    ".megaMenu__innerMenu--item > a[href]",
  );
  const currentUrl = window.location.pathname.replace(/\/$/, "");
  anchors.forEach((anchor) => {
    const anchorUrl = anchor.pathname.replace(/\/$/, "");
    if (anchorUrl === currentUrl) {
      // Step 1: Find the parent .megaMenu__subMenu--item
      const subMenuItem = anchor.closest(".megaMenu__subMenu--item");
      if (subMenuItem) {
        // Step 2: Find the .megaMenu__subMenu--link inside it
        const parentLink = subMenuItem.querySelector(
          ".megaMenu__subMenu--link",
        );
        if (parentLink) {
          parentLink.classList.add("active");
        }
      }
    }
  });
}

export default ActivateMenu;